module.exports = __webpack_public_path__ + "img/THEOS_LOGO_METAL.cded361b.svg";